import React from 'react';
import { CTAButton } from '../CTAButton';
import { KARITO_PHOTO } from '../../data/content';
export function About() {
  return <section className="bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-48" data-mp="oqcho9tmacfi">
      <div className="mx-auto w-full max-w-4xl" data-id="element-49" data-mp="12rf4iosfrqrh">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-cream sm:text-4xl" data-id="element-50" data-mp="12q3zymr62ezb">
          🏥 Sulla Dott.ssa Karito
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border border-ink-line bg-ink-soft sm:grid sm:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]" data-id="element-51" data-mp="ayxwbwc8lz5a">
          <img src={KARITO_PHOTO} alt="Ritratto della Dott.ssa Karito nel suo studio odontoiatrico" className="h-64 w-full object-cover object-top sm:h-full" width={936} height={1170} data-id="element-52" data-mp="5yjmq9uzmh55" />
          <div className="space-y-3 p-6 sm:p-8" data-id="element-53" data-mp="3ng2t3q3jyjhv">
            <p className="text-[14.5px] leading-relaxed text-cream/70" data-id="element-54" data-mp="3nerq3shxlfrt">
              Per anni la Dott.ssa Karito ha seguito pazienti affrontando la
              stessa sfida che vivono migliaia di odontoiatri: casi sempre più
              complessi e troppe decisioni critiche capaci di condizionare il
              risultato finale.
            </p>
            <p className="text-[14.5px] leading-relaxed text-cream/70" data-id="element-55" data-mp="3d0323bwvmynw">
              Col tempo ha capito che il vero problema non era la mancanza di
              conoscenze, ma l’assenza di un metodo chiaro per prendere
              decisioni cliniche con fiducia.
            </p>
            <p className="font-display text-lg font-bold text-gold" data-id="element-56" data-mp="2p8nv35u5nt6b">
              Così è nato Protocollo Clinico Sicuro™.
            </p>
            <p className="text-[14.5px] leading-relaxed text-cream/70" data-id="element-57" data-mp="2u78vp6dbkeva">
              Non un corso in più. Non un libro di teoria. Ma un sistema pratico
              di protocolli, algoritmi e strumenti pensato per aiutare altri
              odontoiatri a ridurre l’incertezza e lavorare con maggiore
              prevedibilità ogni giorno.
            </p>
            <div className="max-w-sm pt-2" data-id="element-58" data-mp="2ajrg2173btoa">
              <CTAButton label="Voglio imparare il suo metodo" data-id="element-59" data-mp="2aipu31ojdmrs" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}